import { v1 as uuid } from 'uuid';
import React, { FunctionComponent } from 'react';
import { Box, FormControl, makeStyles, FormHelperText, TextField } from '@material-ui/core';
import { FormFieldProps } from '../../../FormDisplay/FormFieldDisplay/FormFieldDisplay';

const TextFilterField: FunctionComponent<FormFieldProps> = (props) => {
    const { formField, value, handleInputChange, error } = props;

    const classes = makeStyles(() => ({
        formControl: {
            marginLeft: 15,
            minWidth: 160,
            maxWidth: 160,
        },
    }))();

    return (
        <Box>
            <FormControl className={classes.formControl}>
                <>
                    <TextField
                        label={formField.label || ''}
                        name={formField.field}
                        value={value || ''}
                        onChange={(event) => handleInputChange(formField.field, event.target.value)}
                    />
                    {error?.messages?.map((msg) => (
                        <FormHelperText key={uuid()} error={true}>
                            {msg}
                        </FormHelperText>
                    ))}
                </>
            </FormControl>
        </Box>
    );
};

export default TextFilterField;
